<template>
  <!-- 验证 -->
  <div class="box">
    <div class="content">
      <img class="reg-img" src="../../assets/imgs/verification/register_yanzheng.png" alt="">
      <div class="txt-box">
        <p class="txt" v-if="userTest==='userPone'">我们向您的手机<span class="pone">{{info.loginPhone}}</span>发送了一条验证短信，请输入短信中的验证码：</p>
        <p class="txt" v-if="userTest==='userEmail'">我们向您的邮箱<span class="pone">{{info.loginPhone}}</span>发送了一条验证邮件，请输入邮件中的验证码：</p>
      </div>
      <div class="reg-code">
        <BaseCode @getCode="getCode" />
      </div>
      <div class="btn-box">
        <!-- <el-button class="btn-left" @click="handleBack">上一步</el-button> -->
        <el-button v-if="this.code.length!==4" class="btn-rigth">下一步</el-button>
        <el-button v-if="this.code.length===4" type="primary" class="show-btn-right" @click="handleNext">下一步</el-button>
      </div>
      <!-- 路由为 重置密码显示 -->
      <div class="bottom" v-if="$route.name==='retrievePassword'&&(HAVE_PHONE)">
        <p>收不到验证码,<span class="switch" @click="changeVerifyMode">换一个验证方式></span></p>
      </div>
      <!-- 路由为注册且 VUE_SUPPORT_EMAil为true 显示-->
      <div class="bottom" v-if="$route.name==='registration'&&(HAVE_PHONE)">
        <p>收不到验证码,<span class="switch" @click="changeVerifyMode">换一个验证方式></span></p>
      </div>
    </div>
  </div>
</template>

<script>
// 引入api
import { verifyPhoneCode } from '@/services/loginRegister';
// 验证码组件
import BaseCode from '@/common/base-code.vue';
export default {
  name: "verification",
  props: {
    // 验证信息
    info: {
      type: Object,
      default: () => { }
    },
    // 验证手机号或者邮箱
    userTest: {
      type: String,
      default: "userPone"
    },
    // 控制显示
    stepActive: {
      type: Number,
      required: true
    },

  },
  components: {
    BaseCode
  },
  data() {
    return {
      HAVE_PHONE: HAVE_PHONE,//注册模块---是否支持切换邮箱注册
      code: '', //接收验证码
      activeNum: this.stepActive //步骤条进度
    }
  },
  mounted() {
    // console.log(this.$route);
    // console.log(VUE_SUPPORT_EMAil);
    // console.log(this.userTest, "-----验证类别");
    // console.log(this.info, "---------电话号码/邮箱");
  },
  watch: {},
  computed: {},
  methods: {
    // 获取code值
    getCode(data) {
      this.code = data
      console.log(this.code);
    },
    // 换一个验证方式
    changeVerifyMode() {
      if (this.userTest === 'userPone') {
        this.$emit('changeVerifyMode', 'userEmail')
      } else {
        this.$emit('changeVerifyMode', 'userPone')
      }
      this.$emit('setStepActive', --this.activeNum)
    },
    // 返回上一页
    handleBack() {
      this.$emit('setStepActive', --this.activeNum)
    },
    // 下一步
    async handleNext() {
      if (this.code.length < 4) {
        this.$message.error('请输入4位数验证码')
        return false
      }
      // 接口参数
      const params = {
        loginPhone: this.info.loginPhone,
        verifyCode: this.code
      }
      // 调用注册---验证验证码接口
      const { success, errorDesc } = await verifyPhoneCode(params)
      if (success) {
        // 改变步骤条
        this.$emit('setStepActive', ++this.activeNum)
        // 传递验证码
        this.$emit('sendVerifyCode', this.code)
      } else {
        this.$message.closeAll()
        this.$message({
          message: errorDesc,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/imgs/verification/register_bg2.png") no-repeat;
  .content {
    box-sizing: border-box;
    padding: 0 75px;
    position: absolute;
    top: 127px;
    left: 0px;
    width: 460px;
    height: 400px;
    opacity: 1;
    border-radius: 10px;
    text-align: center;
    .reg-img {
      margin-top: 69px;
      width: 100px;
      height: 40px;
    }
    .txt-box {
      margin-top: 19px;
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 18px;
      .txt {
        .pone {
          color: #0078fc;
        }
      }
    }
    .btn-box {
      width: 100%;
      height: 46px;
      display: flex;
      .btn-left {
        width: 140px;
        height: 46px;
        background: #ffffff;
        border: 1px solid #0078fc;
        border-radius: 8px;
        color: #0078fc;
      }
      .btn-rigth {
        // width: 140px;
        width: 100%;
        height: 46px;
        background: #dedede;
        border-radius: 8px;
        color: #fff;
        border: 1px solid #dedede;
      }
      .show-btn-right {
        width: 100%;
        height: 46px;
        background: #0078fc;
        border-radius: 8px;
        color: #fff;
        border: 1px solid #dedede;
        &:hover {
          background: #3393fd;
          border-color: #3393fd;
        }
        &:active {
          background: #006ce3;
          border-color: #006ce3;
        }
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
    .bottom {
      margin-top: 39px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      .switch {
        color: #0078fc;
        cursor: pointer;
      }
    }
  }
}
</style>